/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Ellipses_Replacement_FailedInputs */

const en_ellipses_replacement_failed = /** @type {(inputs: Ellipses_Replacement_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ellipses replacement failed. ${i?.error}`)
};

const fr_ellipses_replacement_failed = /** @type {(inputs: Ellipses_Replacement_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remplacement par les points de suspension échoué. ${i?.error}`)
};

const de_ellipses_replacement_failed = /** @type {(inputs: Ellipses_Replacement_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Der Austausch der Ellipsen ist fehlgeschlagen. ${i?.error}`)
};

const it_ellipses_replacement_failed = /** @type {(inputs: Ellipses_Replacement_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sostituzione delle ellissi non riuscita. ${i?.error}`)
};

const ru_ellipses_replacement_failed = /** @type {(inputs: Ellipses_Replacement_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Замена эллипсов не удалась. ${i?.error}`)
};

const es_ellipses_replacement_failed = /** @type {(inputs: Ellipses_Replacement_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error en el reemplazo de elipses. ${i?.error}`)
};

const zh_cn2_ellipses_replacement_failed = /** @type {(inputs: Ellipses_Replacement_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`省略号替换失败。${i?.error}`)
};

const ja_ellipses_replacement_failed = /** @type {(inputs: Ellipses_Replacement_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`省略記号の置換に失敗しました。${i?.error}`)
};

const hi_ellipses_replacement_failed = /** @type {(inputs: Ellipses_Replacement_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`दीर्घवृत्त प्रतिस्थापन विफल रहा। ${i?.error}`)
};

const pt_pt2_ellipses_replacement_failed = /** @type {(inputs: Ellipses_Replacement_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A substituição das elipses falhou. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Ellipses replacement failed. {error}" |
*
* @param {Ellipses_Replacement_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ellipses_replacement_failed = /** @type {((inputs: Ellipses_Replacement_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ellipses_Replacement_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ellipses_replacement_failed(inputs)
	if (locale === "de") return de_ellipses_replacement_failed(inputs)
	if (locale === "it") return it_ellipses_replacement_failed(inputs)
	if (locale === "ru") return ru_ellipses_replacement_failed(inputs)
	if (locale === "es") return es_ellipses_replacement_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_ellipses_replacement_failed(inputs)
	if (locale === "ja") return ja_ellipses_replacement_failed(inputs)
	if (locale === "hi") return hi_ellipses_replacement_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_ellipses_replacement_failed(inputs)
	return en_ellipses_replacement_failed(inputs)
});